//话术右键菜单
export default {
  props: ["menuY", "menuX", "cellList"],
  data() {
    return {
      pageHeight: document.documentElement.clientHeight + "px",
      pageWidth: document.documentElement.clientWidth + "px"
    };
  },
  components: {},
  computed: {},
  methods: {
    cellClick(idx) {
      this.$emit("cellClick", idx);
      this.hideMenu();
    },
    edit() {
      this.$emit("edit");
      this.hideMenu();
    },
    remove() {
      this.$emit("remove");
      this.hideMenu();
    },
    hideMenu() {
      this.$emit("hideMenu");
    },
    autoSend() {
      this.$emit("autoSend");
      this.hideMenu();
    }
  },
  async mounted() {}
};